import request from "./axios";

// 导航接口
export const getWebNavigation = (data) => {
  return request.post("/web/info/getWebNavigation", data);
};
// 首页布局接口
export const getWebPosition = (data) => {
  return request.post("/web/info/getWebPosition", data);
};
// 首页头部banner
export const getTopBanner = (data) => {
  return request.get("/web/info/getTopBanner", data);
};
// 首页中间banner
export const getMidBanner = (data) => {
  return request.get("/web/info/getMidBanner", data);
};
// 首页公司新闻轮播
export const getBannerList = (data) => {
  return request.get("/web/info/getBannerList", data);
};
// 首页友情链接
export const getNetLinks = (strType) => {
  return request.get("/web/info/getNetLinks", {strType});
};

// 列表接口
export const getInfoList = (data) => {
  return request.get("/web/info/getInfoList", data);
};
// 详情页接口
export const getInfoDetail = (data) => {
  return request.get("/web/info/getInfoDetail", data);
};


// 获取三级tabs接口
export const getChildCol = (data) => {
  return request.get("/web/info/getChildCol", data);
};
// 头部搜索
export const fullSearchIndex = (data) => {
  return request.get("/web/info/fullSearchIndex", data);
};

// 公司概况图片
export const getInfoPic = (data) => {
  return request.get("/web/info/getInfoPic", data);
};
